import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
    buttonsStyling: false,
    confirmButtonClass: 'btn btn-primary mx-2',
    cancelButtonClass: 'btn btn-light mx-2',
    reverseButtons: true,
    cancelButtonText: 'Avbryt',
};

Vue.use(VueSweetalert2, options);
